import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import data from "./data.json";
import { useDispatch, useSelector } from "react-redux";
import {
  setExternalLink,
  setShowExternalPopup,
} from "../../../redux/slice/slicePopup";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
// import Skeleton from "react-loading-skeleton";

const Menus = () => {
  const POWER_GENERATION_MENU = "Power Generation";
  const POWER_GENERATION_HINDI = "विद्युत उत्पादन";
  const { pathname } = useLocation();
  const subMenuRef = useRef({});
  const [toggleShowClass, setToggleShowClass] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const dispatch = useDispatch();
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: mainMenus = {}, isLoading: mainMenusIsLoading } =
    useGetProtectedApiDataQuery({
      url: "mastermenu",
      lang: languageType,
    });

  const menuItems =
    mainMenus?.menu_items?.length > 0
      ? mainMenus.menu_items
      : data.menu_items || [];

  const handlePopupLink = (link) => {
    dispatch(setShowExternalPopup(true));
    dispatch(setExternalLink(link));
  };

  const getActiveClass = (menu) => {
    if (menu === "/") {
      return pathname === "/" ? "active" : ""; // Exact match for the root path
    }
    return pathname.includes(menu) ? "active" : ""; // Partial match for other paths
  };

  const handleMobileMenu = () => {
    setToggleShowClass(!toggleShowClass);
  };

  const handleSubMenu = (menu, event) => {
    if (event && event.type === "click") {
      const isPowerGeneration =
        menu.title === POWER_GENERATION_MENU ||
        menu.title === POWER_GENERATION_HINDI;
      if (isPowerGeneration) {
        setActiveSubMenu(null);
        return;
      }
    }
    setActiveSubMenu((prev) => (prev === menu.title ? null : menu.title));
  };

  const closeMenuOnItemClick = () => {
    setToggleShowClass(false);
    setActiveSubMenu(null);
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setActiveSubMenu(null);
        setToggleShowClass(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  // Render menu item
  const renderMenuItem = (menu, index) => {
    const hasSubmenu = menu?.submenu?.length > 0;
    const isPowerGeneration =
      menu.title === POWER_GENERATION_MENU ||
      menu.title === POWER_GENERATION_HINDI;
    const isActiveSubMenu = activeSubMenu === menu.title;

    return (
      <li key={index} className={`nav-item ${hasSubmenu ? "menuparent" : ""}`}>
        {hasSubmenu && isPowerGeneration ? (
          // Power Generation menu with special handling
          <Link
            role="button"
            to={menu.url}
            className={`parent-menu ${getActiveClass(menu.url)} ${
              isActiveSubMenu ? "show-submenu" : ""
            }`}
            onClick={(e) => {
              if (e.detail === 0) {
                e.preventDefault();
                handleSubMenu(menu, e);
              } else {
                setActiveSubMenu(null);
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleSubMenu(menu, e);
              }
            }}
          >
            {menu.title}
          </Link>
        ) : hasSubmenu ? (
          // Regular menu with submenu
          <a
            role="button"
            href="#"
            className={`parent-menu ${getActiveClass(menu.url)} ${
              isActiveSubMenu ? "show-submenu" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleSubMenu(menu);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleSubMenu(menu, e);
              }
            }}
          >
            {menu.title}
          </a>
        ) : (
          // Simple menu item without submenu
          <Link
            to={menu.url}
            className={`parent-menu ${getActiveClass(menu.url)}`}
            onClick={closeMenuOnItemClick}
          >
            {menu.title}
          </Link>
        )}

        {hasSubmenu && renderSubMenu(menu)}
      </li>
    );
  };

  // Render submenu
  const renderSubMenu = (menu) => {
    const shouldHidePowerGeneration = (submenu) =>
      (submenu.title === POWER_GENERATION_MENU ||
        submenu.title === POWER_GENERATION_HINDI) &&
      screenWidth > 738;

    return (
      <ul
        className="sub-menu"
        ref={(el) => (subMenuRef.current[menu.title] = el)}
      >
        {menu.submenu.map((submenu, subIndex) =>
          shouldHidePowerGeneration(submenu) ? null : (
            <li key={subIndex} className="item-list">
              {submenu.external ? (
                <a
                  href="#"
                  title={submenu.title}
                  onClick={(e) => {
                    e.preventDefault();
                    handlePopupLink(submenu.url);
                  }}
                  rel="noopener noreferrer"
                >
                  {submenu.title}
                </a>
              ) : (
                <Link
                  title={submenu.title}
                  to={submenu.url}
                  className={getActiveClass(submenu.url)}
                  onClick={closeMenuOnItemClick}
                >
                  {submenu.title}
                </Link>
              )}
            </li>
          )
        )}
      </ul>
    );
  };

  return (
    <>
      <div className="nav-wraper">
        <nav className="navbar navbar-expand-lg navbar-light custom-nav w-100">
          <button
            className="navbar-toggler"
            type="button"
            onClick={handleMobileMenu}
          >
            {!toggleShowClass ? (
              <i className="fas fa-bars"></i>
            ) : (
              <i className="fas fa-times"></i>
            )}
          </button>
          <div
            className={`collapse navbar-collapse ${
              toggleShowClass ? "show" : ""
            }`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav mr-auto">
              {mainMenusIsLoading ? (
                [...Array(7)].map((_, i) => (
                  <li key={i} className="nav-item mx-2">
                    <div className="menu-loading">
                      {/* <Skeleton
                        width="80%"
                        height="80%"
                        baseColor="#6e6e6e"
                        highlightColor="#fff"
                        borderRadius={4}
                      /> */}
                    </div>
                  </li>
                ))
              ) : menuItems.length > 0 ? (
                menuItems.map(renderMenuItem)
              ) : (
                <li>No Menu Found</li>
              )}
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Menus;
